import { Component, EventEmitter, Input, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent implements OnInit {
  
  ngOnInit(): void {

  }

  @Input() imageUrl: string;
  @Input() show: boolean = false;

  @Output() closeViewer = new EventEmitter<void>();

  constructor(private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.show) {
      if (this.show) {
        this.renderer.setStyle(document.body, 'overflow', 'hidden');
      } else {
        this.renderer.removeStyle(document.body, 'overflow');
      }
    }
  }

  close() {
    this.closeViewer.emit();
    this.renderer.removeStyle(document.body, 'overflow');
  }
}